import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../contexts/userContext';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import StopRoundedIcon from '@material-ui/icons/StopRounded';
import TextField from '@material-ui/core/TextField';
import Swal from 'sweetalert2';
import { Autocomplete } from '@material-ui/lab';
import { Checkbox } from '@material-ui/core';
import { Button } from '@material-ui/core';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const getAllMachinesURL = `/machines/getSuperAdminMC/`;
const getAllEmployeesURL = `/users/getAllEmployees`;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(-5.6),
    marginRight: theme.spacing(40),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function ViewAllMachines(props) {
  function bytesToMegabytes(bytes) {
    return bytes / (1024 * 1024);
  }
  const user = JSON.parse(localStorage.getItem('user'));
  const isSuperAdmin = user.role === 'SuperAdmin' ? true : false;
  const [employees, setEmployees] = useState([]);
  const [targetV, setTargetV] = useState('');
  const [users, setUsers] = useState([]);

  const [isloading, setIsLoading] = useState(false);

  const [reFresh, setRefresh] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [machine, setMachine] = useState(null);
  const [client, setClient] = useState(null);

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_allMachine')
      ? localStorage.getItem('table_view_allMachine')
      : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_allMachine', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      if (isSuperAdmin) {
        await request({
          method: 'get',
          url: getAllEmployeesURL,
        }).then((res) => {
          if (!isCancelled) {
            console.log('userusers', res.data);
            setUsers(res.data);
            setIsLoading(true);
            console.log(res.data);
          }
        });
      }
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllMachines() {
      await request({
        method: 'get',
        url: getAllMachinesURL + process.env.REACT_APP_ENV1,
      }).then((res) => {
        if (!isCancelled) {
          console.log('allmachine', res.data);
          res.data?.forEach((element) => {
            if (element?.status_info === 'Out Of Service') {
              element.oos = 'NO';
            }
            if (element?.appStatus === 'false') {
              element.background = 'In Background';
            }
            element.online = 'false';
            if (element.active) {
              const diff = new Date().getTime() - new Date(element.active);
              if (diff <= 90000) {
                element.online = 'true';
                if (element?.status_info === 'Out Of Service' || element?.appStatus === 'false') {
                  element.online = 'oos';
                }
              }
            }
          });
          setIsLoading(true);
          setEmployees(res.data);
        }
      });
    }

    getAllMachines();

    return () => {
      isCancelled = true;
    };
  }, [reFresh]);

  const columns = [
    { title: 'update', field: 'update_app.update', type: 'boolean' },
    { title: 'ID', field: 'name', editable: 'never' },
    { title: 'Description', field: 'description', editable: 'never' },
    { title: 'Model', field: 'model', editable: 'never' },
    { title: 'Belongs To', field: 'belongTo', editable: 'never' },
    { title: 'Version', field: 'version', editable: 'never' },
    // { title: 'Target V', field: 'update_app.target_version', editable: 'never' },
    {
      title: 'Free Disk',
      field: 'freedisk',
      editable: 'never',
      render: (rowData) => {
        if (rowData.freedisk) {
          return parseInt(bytesToMegabytes(rowData.freedisk)) + 'MB';
        }
      },
      customSort: (a, b) => {
        const c =
          a.freedisk === undefined || a.freedisk === null ? -Infinity : parseFloat(a.freedisk);
        const d =
          b.freedisk === undefined || b.freedisk === null ? -Infinity : parseFloat(b.freedisk);
        return c - d;
      },
    },
    {
      title: 'Temp℃',
      editable: 'never',
      render: (rowData) => {
        if (rowData.tempData?.curr_temp) {
          let currentTemp = parseInt(rowData.tempData?.curr_temp);
          let targetTemp = parseInt(rowData.tempData?.target_temp);
          let tempRange = parseInt(rowData.tempData?.temp_range);
          let finalString = ``;
          let color = 'lightgrey';
          if (rowData.tempData?.temp_control == '1') {
            finalString += `${currentTemp}-${targetTemp}(${tempRange})`;
            if (currentTemp >= targetTemp - tempRange && currentTemp <= targetTemp + tempRange) {
              color = 'green';
            } else {
              color = 'red';
            }
          } else {
            finalString += rowData.tempData?.curr_temp ? rowData.tempData?.curr_temp : '';
          }
          return (
            <div>
              <StopRoundedIcon style={{ color: color }} />
              {finalString}
            </div>
          );
        }
      },
    },
    // { title: 'ObjectId', field: '_id', editable: 'never' },
    {
      title: 'Status',
      field: 'online',
      editable: 'never',
      render: (rowData) => {
        if (rowData.online === 'true') {
          return (
            <div>
              <StopRoundedIcon style={{ color: 'green' }} />
            </div>
          );
        } else if (rowData.online === 'false') {
          return (
            <div>
              <StopRoundedIcon style={{ color: 'lightgrey' }} />
            </div>
          );
        } else if (rowData.online === 'oos') {
          return (
            <div>
              <StopRoundedIcon style={{ color: 'red' }} />
            </div>
          );
        }
      },
    },
    {
      title: 'In Service',
      field: 'oos',
      editable: 'never',
    },
    {
      title: 'In Background',
      field: 'background',
      editable: 'never',
    },
  ];

  // const updateTargetVersion = (id) => {
  //   console.log('option', id);
  //   console.log('targetV', targetV);

  //   let newArray = Object.values(id);
  //   newArray = newArray.map((e) => e.newData);
  //   newArray = newArray.map((e) => e._id);
  //   console.log(`newArray`, newArray);

  //   if (newArray.length > 0) {
  //     request({
  //       method: 'post',
  //       url: `/machines/updateTargetVersion`,
  //       data: {
  //         machineID: newArray,
  //         target_version: targetV,
  //       },
  //     })
  //       .then((res) => {
  //         console.log('res', res.data);
  //         Swal.fire({
  //           icon: 'success',
  //           title: 'Success',
  //           text: 'Target version updated successfully',
  //         });
  //         setRefresh(!reFresh);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: 'Failed to update target version',
  //         });
  //       });
  //   }
  // };

  const transferMachine = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this! Please delete the images under edit machine UI Modal before transfering",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, transfer it!',
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'post',
          url: `/machines/transferMachine`,
          data: {
            machineID: machine._id,
            clientID: client._id,
          },
        })
          .then((res) => {
            console.log('res', res.data);
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Machine transfered successfully',
            });
          })
          .catch((err) => {
            console.error(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to transfer machine',
            });
          });
      }
    });
  };

  const handleSubmit = () => {
    console.log('Submit', selectedRows);
    let newArray = [...selectedRows];
    newArray = newArray.map((e) => e._id);
    console.log(`newArray`, newArray);

    if (newArray.length > 0) {
      request({
        method: 'post',
        url: `/machines/updateTargetVersion`,
        data: {
          machineID: newArray,
          target_version: targetV,
        },
      })
        .then((res) => {
          console.log('res', res.data);
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Target version updated successfully',
          });
          setRefresh(!reFresh);
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update target version',
          });
        });
    }
  };

  return (
    <div>
      {isSuperAdmin && (
        <div
          style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}
        >
          <div
            style={{
              width: '25%',
              margin: '30px',
            }}
          >
            <Autocomplete
              //  value={prodValue}
              options={employees}
              value={machine}
              onChange={(event, value) => {
                //  setProdValue(value);
                setMachine(value);
              }}
              getOptionSelected={(option, value) => option.name === value.name}
              getOptionLabel={(option) => option.name + '(' + option.description + ')'}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name + '(' + option.description + ')'}
                </React.Fragment>
              )}
              fullWidth
              renderInput={(params) => <TextField {...params} variant="outlined" label="Machine" />}
            />
          </div>
          <div style={{ width: '30%', marginRight: '30px' }}>
            <Autocomplete
              //  value={prodValue}
              options={users}
              value={client}
              onChange={(event, value) => {
                //  setProdValue(value);
                setClient(value);
              }}
              getOptionSelected={(option, value) => option._id === value._id}
              getOptionLabel={(option) => option.groupname + '(' + option.groupCode + ')'}
              renderOption={(option, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.groupname + '(' + option.groupCode + ')'}
                </React.Fragment>
              )}
              fullWidth
              renderInput={(params) => <TextField {...params} variant="outlined" label="User" />}
            />
          </div>
          <Button
            onClick={transferMachine}
            type="submit"
            variant="contained"
            color="primary"
            disabled={!machine || !client}
          >
            Transfer Machine
          </Button>
        </div>
      )}

      {/* {isSuperAdmin && (
        <div className="pt-4 pb-4 d-flex justify-content-center" style={{ margin: 'auto' }}>
          <TextField
            style={{ marginRight: '40px' }}
            label="Target Version"
            variant="outlined"
            required
            onChange={(e) => {
              setTargetV(e.target.value);
            }}
            inputProps={{
              maxLength: '30',
            }}
          />
          <Button
            onClick={handleSubmit}
            disabled={selectedRows?.length === 0}
            type="submit"
            variant="contained"
            color="primary"
          >
            Submit
          </Button>
        </div>
      )} */}
      {!isloading && <LoadingIcon />}
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          // editable={
          //   isSuperAdmin && {
          //     onBulkUpdate: (changes) =>
          //       new Promise((resolve, reject) => {
          //         setTimeout(() => {
          //           updateTargetVersion(changes);
          //           resolve();
          //         }, 1000);
          //       }),
          //   }
          // }
          onChangeRowsPerPage={setPagination}
          columns={columns}
          data={employees}
          title={'View All Machines'}
          onSelectionChange={(rows) => setSelectedRows(rows)}
          options={{
            selection: isSuperAdmin ? true : false,
            // filtering: true,
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [20, 50, 100],
          }}
        />
        <BackButton />
      </div>
    </div>
  );
}
